// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

import { StoneCutTranslationFragmentDoc } from './stoneCutTranslation.fragment.generated';
export const StoneCutFragmentDoc = `
    fragment stoneCut on StoneCut {
  systemCode
  translation(locale: $locale) {
    ...stoneCutTranslation
  }
}
    `;